import jsBridge from './utils/bridge.mjs';
import { API_SHOW_SKU_SELECTOR_MODAL } from './utils/constant.mjs';
export var SkuConfirmAction;
(function (SkuConfirmAction) {
    /**
     * 加入购物车
     */
    SkuConfirmAction[SkuConfirmAction["AddToCart"] = 1] = "AddToCart";
    /**
     * 立即购买
     */
    SkuConfirmAction[SkuConfirmAction["BuyNow"] = 2] = "BuyNow";
    /**
     * 无
     */
    SkuConfirmAction[SkuConfirmAction["None"] = 3] = "None";
})(SkuConfirmAction || (SkuConfirmAction = {}));
/**
 * 显示商品 sku 选择器模态框
 * @returns
 */
export function showSkuSelectorModal(params) {
    if (!params.confirmAction) {
        params.confirmAction = SkuConfirmAction.AddToCart;
    }
    if (!('prePage' in params)) {
        params.prePage = '';
    }
    if (!('index' in params)) {
        params.index = 0;
    }
    if (typeof params.goodsId === 'string') {
        params.goodsId = parseInt(params.goodsId);
    }
    if (typeof params.index === 'string') {
        params.index = parseInt(params.index);
    }
    return jsBridge.callPromise({
        minVersion: '1.0.4',
        timeout: 0
    }, API_SHOW_SKU_SELECTOR_MODAL, params);
}
